<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12" class="text-center mb-4">
            <h5 class='complain-title'>{{ $t('globalTrans.payment') }}</h5>
        </b-col>
        <b-col lg="12" sm="12">
            <b-overlay :show="loading">
            <template>
                <b-row v-if="is_payment">
                    <b-col class="text-dark">
                        <b-button @click="is_payment = false" class="btn btn-sm btn-warning"><span><i class="ri-arrow-left-line"></i>Back</span></b-button>
                    </b-col>
                    <b-col class="mt-3" lg="12" sm="12">
                        <div class="text-center">
                            <b-form-radio-group
                            v-model="payment_type_id"
                            :options="paymentTypeList"
                            ></b-form-radio-group>
                        </div>
                        <keep-alive>
                            <component v-bind:is="comp" :type_id="search.type_id" :edit_payment="search.edit_payment" :payment="payment" @clicked="onClickChild"></component>
                        </keep-alive>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col lg="12" sm="12" md="12">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(searchOrder)" @reset.prevent="reset">
                            <b-row>
                                 <b-col xl="6" lg="6" sm="6">
                                    <ValidationProvider name="Agent Type" vid="type_id" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="type_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('retailerManagement.Demand_for')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-radio-group
                                                v-model="search.type_id"
                                                :options="getAgentTypeList"
                                                class="mb-3"
                                                value-field="item"
                                                text-field="name"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-radio-group>
                                            <div class="invalid-feedback d-block">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="4" sm="12">
                                    <ValidationProvider name="Product Cagetory" vid="category_id" rules="">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="category_id "
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('production_store.pro_category')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="search.category_id"
                                            id="category_id"
                                            :options="categoryList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="4" sm="12">
                                    <!-- <ValidationProvider name="Dealer/Retailer" vid='user_id' rules='required|min:1'> -->
                                    <ValidationProvider name="Dealer/Retailer/Sales Center" vid='user_id' rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="user_id "
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('sales_distribution_admin.dealer_retailer')}}<span>{{ currentLocale == 'bn' ? '/বিক্রয় কেন্দ্র' : '/Sales Center'}}</span>
                                                <span class="text-danger">*</span>
                                            </template>
                                            <v-select
                                                id = 'user_id'
                                                v-model="del_retail_item"
                                                :options="agentNameList"
                                                label="text"
                                                @input="setUserId($event)"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                :reduce="item => item.value"
                                                :filter-by="myFilter"
                                            >
                                             <template v-slot:first>
                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                            </v-select>
                                             <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="4" sm="4">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="delivery_order_id"
                                    >
                                        <template v-slot:label>
                                            {{$t('retailerManagement.delivery_order_id')}}
                                        </template>
                                        <b-form-input
                                        id="delivery_order_id"
                                        v-model="search.delivery_order_id"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4" sm="4">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="receive_id"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.production.receive_id')}}
                                        </template>
                                        <b-form-input
                                        id="receive_id"
                                        v-model="search.receive_id"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4" sm="4">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="manual_bill_no"
                                    >
                                        <template v-slot:label>
                                            {{$t('retailerManagement.manual_bill_no')}}
                                        </template>
                                        <b-form-input
                                        id="manual_bill_no"
                                        v-model="search.manual_bill_no"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <div class="col-md-12 text-right">
                                    <b-button type="submit" class="btn btn-success">{{ $t('globalTrans.search') }}</b-button>
                                </div>
                            </b-row>
                        </b-form>
                    </ValidationObserver>
                    <div v-if="search.user_id">
                        <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('sales_distribution_admin.dealer_retailer') + ' ' + $t('globalTrans.details') }}</u></p>
                        <table  class="table table-bordered table-sm" width="50%">
                            <tr>
                                <td width="25%">
                                    {{$t('sales_distribution_admin.dealer_retailer_name')}}
                                </td>
                                <td>: {{ getNameDealerName(this.search.user_id) }}</td>
                            </tr>
                            <tr>
                                <td>
                                    {{$t('sales_distribution_admin.contact_no')}}
                                </td>
                                <td>: {{ getNameDealerContact(this.search.user_id) }}</td>
                            </tr>
                        </table>
                    </div>
                    </b-col>
                   <b-col lg="6" sm="6" offset-lg="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('externalUser.select_receive_order')"
                            label-for="receive_id"
                            >
                        <v-select
                            v-model="receive_id"
                            multiple
                            :options="receiveList"
                            label="text"
                            :reduce="item => item.value"
                        >
                            <template v-slot:option="option">
                            <div class="row">
                                <div class="col-md-6">
                                <span class="fa fa-list"></span>
                                {{ option.text }}
                                </div>
                                <div class="col-md-6 text-right">
                                ({{ option.receive_date }})
                                </div>
                            </div>
                            </template>
                        </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-row v-if="showPayment">
                            <b-col lg="12" v-for="(itm, indx) in singleOrder" :key="indx"  sm="12">
                                <span style="font-size: 20px;font-weight:bold" class="text-dark"><u>{{ $t('externalUser.receive_list') }}</u></span>
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.quantity') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                                    </b-tr>
                                    <b-tr v-for="(item, index) in itm.details" :key="index">
                                        <b-td>{{ $n(index + 1) }}</b-td>
                                        <b-td>{{ productNameById(item.product_id) }}</b-td>
                                        <b-td>{{ $n(item.quantity) }}</b-td>
                                        <b-td>{{ $n(item.receive_quantity) }}</b-td>
                                        <b-td>{{ $n(item.unit_price) }}</b-td>
                                        <b-td>{{ $n(item.total_price) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.net_amount') }} </span>
                                        </b-td>
                                        <b-td>
                                            {{ $n(itm.total_amount) }}
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.vat') }} (-) </span>
                                        </b-td>
                                        <b-td>
                                            <b-form-input
                                                placeholder=""
                                                id="vat"
                                                @keyup="calculateGrandTotal(itm)"
                                                v-model="itm.vat"
                                                min="0"
                                            >
                                            </b-form-input>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('globalTrans.tax') }} (-) </span>
                                        </b-td>
                                        <b-td>
                                            <b-form-input
                                                placeholder=""
                                                id="vat"
                                                min="0"
                                                @keyup="calculateGrandTotal(itm)"
                                                v-model="itm.tax"
                                            >
                                            </b-form-input>
                                        </b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(itm.grand_total) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="5">
                                            <span style="margin-left:80%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(itm.due_amount) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </b-col>
                            <div class="col-md-12">
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:80%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(getAllGrandTotal(singleOrder)) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:80%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(getDueGrandTotal(singleOrder)) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </div>
                            <div class="col-md-12">
                                <div class="text-right">
                                    <b-button @click="setPayment(singleOrder, 0)" class="btn btn-success btn-sm" style="width:90px">{{ $t('externalUser.full_pay') }}</b-button>
                                    <b-button v-if="singleOrder.length === 1" @click="setPayment(singleOrder, 1)" class="btn btn-success btn-sm ml-2"  style="width:90px">{{ $t('externalUser.pertial_pay') }}</b-button>
                                </div>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="row mt-4">
                    <div class="col-md-12 text-right">
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-payment')">{{ $t('globalTrans.close') }}</b-button>
                    </div>
                </div>
            </template>
            </b-overlay>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { deliveryRecPayList } from '../../api/routes'
import PaymentOthers from './PaymentOthers'
import PaymentCash from './PaymentCash'
import PaymentCheck from './PaymentCheck'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components: {
    PaymentCheck,
    PaymentCash,
    PaymentOthers,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
        search: {
            delivery_order_id: '',
            receive_id: '',
            edit_payment: false,
            user_id: '',
            type_id: '',
            category_id: 0
        },
        del_retail_item: '',
        is_payment: false,
        receive_id: '',
        comp: 'PaymentCash',
        dealerId: 0,
        receiveList: [],
        loading: false,
        singleOrder: '',
        showPayment: false,
        payment_type_id: 3,
        payment: {
            is_partial: '',
            paymentList: ''
        },
        agentNameList: [],
        optionsTypeList: [
            { item: 1, text_en: 'Dealer', text_bn: 'ডিলার' },
            { item: 2, text_en: 'Retailer', text_bn: 'খুচরা বিক্রেতা' },
            { item: 3, text_en: 'Sales Center', text_bn: 'বিক্রয় কেন্দ্র' }
        ]
    }
  },
  created () {
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    paymentTypeList () {
        return this.productCommonObj.paymentTypeList.filter(item => item.value !== 1)
    },
    dealerRetailerList () {
        return this.productCommonObj.dealerRetailerList
    },
    getAgentTypeList: function () {
        return this.optionsTypeList.map(item => {
            return Object.assign({}, item, { name: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    currentLocale () {
      return this.$i18n.locale
    },
    categoryList () {
        return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    }
  },
  watch: {
    payment_type_id: function (n, o) {
        if (n !== o) {
          if (n === 2) {
              this.comp = 'PaymentCheck'
          } else if (n === 4) {
            this.comp = 'PaymentOthers'
          } else {
              this.comp = 'PaymentCash'
          }
        }
    },
    'search.type_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.getDealerRetailerListByType()
        }
    },
    receive_id: function (n, o) {
        if (n !== o) {
         this.getOrderDetails(n)
        }
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    myFilter (option, text, search) {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    setUserId (event) {
        this.search.user_id = event
    },
    onClickChild () {
      this.$bvModal.hide('modal-payment')
    },
    searchOrder () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, deliveryRecPayList, this.search).then(response => {
            if (response.success) {
                const tmpData = response.data.map(item => {
                    return Object.assign(item, { value: item.id, text: item.receive_id, title: item.receive_id })
                })
                this.receiveList = tmpData
                this.loading = false
            }
        })
    },
    getOrderDetails (Ids) {
        if (Ids.length) {
            this.singleOrder = []
            Ids.map(Id => {
                this.showPayment = true
                const tmpData = this.receiveList.find(item => item.id === parseInt(Id))
                const tmp = JSON.parse(JSON.stringify(tmpData))
                let grandTotal = 0
                if (tmp.vat > 0 || tmp.tax > 0) {
                    grandTotal = tmp.grand_total
                }
                this.singleOrder.push(Object.assign(tmp, { total_price: this.calculateNetAmount(tmp), grand_total: grandTotal > 0 ? grandTotal : this.calculateNetAmount(tmp) }))
            })
        } else {
            this.singleOrder = []
            this.showPayment = false
        }
    },
    calculateGrandTotal (item) {
        const result = item.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
        const vat = isNaN(item.vat) || item.vat === '' ? 0 : parseFloat(item.vat)
        const tax = isNaN(item.tax) || item.tax === '' ? 0 : parseFloat(item.tax)
        const total = (parseFloat(result) - (vat + tax))
        item.grand_total = isNaN(total) ? item.total_price : total
    },
    calculateNetAmount (tmp) {
      const result = tmp.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
      const total = parseFloat(result)
      return total
    },
    totalVat (tmp) {
      const result = tmp.details.reduce((total, item) => total + parseFloat(item.vat), 0)
      const total = parseFloat(result)
      return total
    },
    totalTax (tmp) {
      const result = tmp.details.reduce((total, item) => total + parseFloat(item.tax), 0)
      const total = parseFloat(result)
      return total
    },
    getAllGrandTotal (tmp) {
      const result = tmp.reduce((total, item) => total + parseFloat(item.total_amount), 0)
      const total = parseFloat(result)
      return total
    },
    getDueGrandTotal (tmp) {
      const result = tmp.reduce((total, item) => total + parseFloat(item.due_amount), 0)
      const total = parseFloat(result)
      return total
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    getNameDealerName (id) {
        let user
        if (this.search.type_id <= 2) {
            user = this.productCommonObj.dealerRetailerList.find(product => product.value === id)
        } else {
            user = this.$store.state.commonObj.officeList.find(product => product.value === id)
        }
        if (typeof user !== 'undefined') {
            if (this.$i18n.locale === 'bn') {
            return user.text_bn
            } else {
                return user.text_en
            }
        } else {
            return ''
        }
    },
    getNameDealerContact (id) {
        const user = this.productCommonObj.dealerRetailerList.find(product => product.value === id)
        if (typeof user !== 'undefined') {
            return user.contact_no
        } else {
            return ''
        }
    },
    setPayment (item, ispartial) {
        this.is_payment = true
        this.payment.is_partial = ispartial
        this.payment.paymentList = item
    },
    getPaymentStatus (status) {
        const Status = this.$store.state.ExternalUser.commonObj.paymentStatusList.find(item => item.value === status)
        if (this.$i18n.locale === 'bn') {
            return Status.text_bn
        } else {
            return Status.text_en
        }
    },
    paidCheck () {
        const data = this.singleOrder.details.filter(item => {
            if (item.payment_status === 0) {
                return item
            }
        })
        if (data.length === this.singleOrder.details.length) {
            return 1
        } else {
            return 0
        }
    },
    getDealerRetailerListByType () {
        const typeId = this.search.type_id
        if (typeId <= 2) {
            this.agentNameList = this.productCommonObj.dealerRetailerList.filter(item => item.type === typeId).map(Obj => {
                return Object.assign({}, Obj,
                    { value: Obj.value, text: this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn }
                )
            })
            if (typeId === 2) {
                this.agentNameList.push({ value: 1, text: this.$t('child_admission_management.others'), text_en: '', text_bn: '' })
            }
        } else {
            this.agentNameList = this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
        }
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
